import React from "react";

import { RadioInput, RadioInputProps } from "@packages/ds";

import { sendPendoEventRadio } from "Store/analytics/pendoFunctions";

export interface TrackedRadioInputProps extends RadioInputProps {
  /** Analytics ID for tracking events (defaults to id if not provided) */
  analyticId?: string;
}

/**
 * Radio input with analytics tracking
 */
export const TrackedRadioInput = ({
  id,
  analyticId,
  onClick,
  ...props
}: TrackedRadioInputProps) => {
  const handleClick = (e: React.MouseEvent) => {
    const trackingId = analyticId || id;
    sendPendoEventRadio(trackingId);
    onClick?.(e);
  };

  return <RadioInput {...props} id={id} onClick={handleClick} />;
};
